import React, {useEffect} from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Collapse from '@mui/material/Collapse';
import { useTheme } from '@mui/material/styles';

import WebServiceGet from '../Connectors/WebServiceGet';

import CustomSelectFieldNGX from './CustomSelectFieldNGX';
import CustomTextFieldNGX from './CustomTextFieldNGX';
import AutocompletePlz from './AutocompletePlz';
import rulesText from '../Entity/rulesText';
import validatorResult from '../Entity/validatorResult';
import ValidatorInputText from '../Module/Validatoren/ValidatorInputText';
import ValidatorInputCustomPlz from '../Module/Validatoren/ValidatorInputCustomPlz';



const validatorText = (props, fieldName, rules) => {
    if (!props.data[fieldName].touched) {
        return validatorResult(true)
    }

    if (props.data[fieldName].overrideValidator) {
        let res = props.data[fieldName].overrideValidator()
        if (res.valid !== props.data[fieldName].valid) {
            useEffect(() => {
                props.updaterValid(fieldName)(res.valid)
            }, [])
        }
        return res
    }

    if (props.data[fieldName].overrideRules) {
        rules = props.data[fieldName].overrideRules
    }

    let res =  ValidatorInputText(
        props.data[fieldName].value, rules
    );

    if (res.valid !== props.data[fieldName].valid) {
        useEffect(() => {
            props.updaterValid(fieldName)(res.valid)
        }, [])
    }

    return ValidatorInputText(
        props.data[fieldName].value, rules
    );
}

const Person = (props) => {
    if ( props.withCard ) {
        return CardCapsule(props);
    }
    const theme = useTheme();
    return (
        <div>
            <CardHeader
                avatar={<Avatar style={{backgroundColor:theme.palette.primary.main}}><PersonIcon /></Avatar>}
                title={<h2 style={{color:theme.palette.primary.main}}>{props.headline}</h2>}
                action={
                    <IconButton sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}} 
                      aria-label="Exemplar löschen"
                      onClick={
                        ()=> {
                          props.updaterValue("zoomIn")(!props.data.zoomIn.value)
                        }
                      }
                    >
                      {
                        props.data.zoomIn.value
                        ?<ExpandLessIcon />
                        :<ExpandMoreIcon />
                      }
                    </IconButton>
                }
                style={{padding:"0px"}} // CardHeader default padding override
            />
            <Collapse in={props.data.zoomIn.value}>
                {PersonForm(props)}
            </Collapse>
        </div>
    );
}


const CardCapsule = (props) => {
    const theme = useTheme();
    return (
        <Card>
            {props.headline &&
                <CardHeader
                    avatar={<Avatar style={{backgroundColor:theme.palette.primary.main}}><PersonIcon /></Avatar>}
                    title={<h2 style={{color:theme.palette.primary.main}}>{props.headline}</h2>}
                    action={
                        <IconButton sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}} 
                          aria-label="Exemplar löschen"
                          onClick={
                            ()=> {
                              props.updaterValue("zoomIn")(!props.data.zoomIn.value)
                            }
                          }
                        >
                          {
                            props.data.zoomIn.value
                            ?<ExpandLessIcon />
                            :<ExpandMoreIcon />
                          }
                        </IconButton>
                    }
                />
            }
            <Collapse in={props.data.zoomIn.value}>
            <CardContent>
                {PersonForm(props)}
            </CardContent>
            </Collapse>
        </Card>
    );
}

const PersonForm = (props) => {
    return (
        <div>
            <Grid container spacing={2}>

                <Grid item md={(props.data['personTyp'].value== "istInstitution") ? 4 : 12} xs={12}>
                        <CustomSelectFieldNGX
                            id={props.id+"PrivatpersonOderFirma"}
                            label="Privatperson, Firma, ..."
                            value={props.data['personTyp'].value}
                            updaterValue={props.updaterValue('personTyp')}
                            touched={props.data['personTyp'].touched}
                            updaterTouch={props.updaterTouch('personTyp')}
                            updaterValid={props.updaterValid('personTyp')}
                            list={[
                                {
                                    id:'istPrivatperson',
                                    label:'Privatperson',
                                },
                                {
                                    id:'istInstitution',
                                    label:'Firma/Institution/Händler/Zuchtgemeinschaft',
                                }                 
                            ]}
                            required={true}
                            validator={
                                () => validatorText(props,
                                    "personTyp",
                                    rulesText(true,1)
                                )  
                            }
                        />
                </Grid>

                {props.data.personTyp.value == 'istInstitution' &&
                    <Grid item md={8} xs={12}>
                        <CustomTextFieldNGX
                            label="Firma/Institution/Händler/Zuchtgemeinschaft"
                            data={props.data.institution}
                            updaterValue={props.updaterValue('institution')}
                            updaterTouch={props.updaterTouch('institution')}
                            required={true}
                            validator={
                                () =>  validatorText(props, "institution", rulesText(true,2))
                            }
                            inputProps={{ 'aria-label': 'Name der Firma oder Institution' }}
                        />
                    </Grid>
                }

                {props.data['anrede'].display && props.data['anrede'].value != "eigene" &&
                <Grid item lg={2} md={2} sm={6} xs={12}>
                    <CustomSelectFieldNGX
                        id={props.id+"Anrede"}
                        label="Anrede"
                        name="honorific-prefix"
                        value={props.data['anrede'].value}
                        updaterValue={props.updaterValue('anrede')}
                        touched={props.data['anrede'].touched}
                        updaterTouch={props.updaterTouch('anrede')}
                        list={[
                            {
                                id:'Herr',
                                label:'Herr',
                            },
                            {
                                id:'Frau',
                                label:'Frau',
                            },
                            {
                                id:'eigene',
                                label:'Eigene Angabe',
                            }
                        ]}
                    />
                </Grid>
                }

                {props.data['anrede'].display && props.data['anrede'].value == "eigene" &&
                <Grid item lg={2} md={2} sm={6} xs={12}>
                    <CustomTextFieldNGX
                        label="Anrede"
                        data={props.data.anredeIndividuell}
                        updaterValue={props.updaterValue('anredeIndividuell')}
                        updaterTouch={props.updaterTouch('anredeIndividuell')}
                        required={false}
                        validator={
                            () => validatorResult(true)
                        }
                        inputProps={{ 'aria-label': 'Anrede' }}
                    />
                </Grid>
                }

                {props.data['titel'].display && props.data['titel'].value != "eigene" &&
                <Grid item lg={1} md={2} sm={6} xs={12}>
                    <CustomSelectFieldNGX
                        id={props.id+"Titel"}
                        label="Titel"
                        name="honorific-suffix"
                        value={props.data['titel'].value}
                        updaterValue={props.updaterValue('titel')}
                        touched={props.data['titel'].touched}
                        updaterTouch={props.updaterTouch('titel')}
                        list={[
                            {
                                id:'Prof.',
                                label:'Prof.',
                            },
                            {
                                id:'Dr.',
                                label:'Dr.',
                            },
                            {
                                id:'eigene',
                                label:'Eigene Angabe',
                            }
                        ]}
                    />
                </Grid>
                }

                {props.data['titel'].display && props.data['titel'].value == "eigene" &&
                <Grid item lg={2} md={2} sm={6} xs={12}>
                    <CustomTextFieldNGX
                        label="Titel"
                        data={props.data.titelIndividuell}
                        updaterValue={props.updaterValue('titelIndividuell')}
                        updaterTouch={props.updaterTouch('titelIndividuell')}
                        required={false}
                        validator={
                            () => validatorResult(true)
                        }
                        inputProps={{ 'aria-label': 'Titel' }}
                    />
                </Grid>
                }


                {props.data['personTyp'].value == "istInstitution" &&
                <Grid item lg={3} md={4} sm={6} xs={12}>
                    <CustomTextFieldNGX
                        id={props.id+"Vorname"}
                        label="Vorname Ansprechpartner"
                        data={props.data.vorname}
                        updaterValue={props.updaterValue('vorname')}
                        updaterTouch={props.updaterTouch('vorname')}
                        required={props.konfiguration.pflichtfelder.vornameJuristischePerson}
                        validator={
                            props.konfiguration.pflichtfelder.vornameJuristischePerson
                            ?() => validatorText(props,
                                "vorname",
                                rulesText(true,2)
                            )
                            :() => validatorResult(true)
                        }
                        inputProps={{ 'aria-label': 'Vorname' }}
                    />
                </Grid>
                }

                {props.data['personTyp'].value != "istInstitution" &&
                <Grid item lg={3} md={4} sm={6} xs={12}>
                    <CustomTextFieldNGX
                        id={props.id+"Vorname"}
                        label="Vorname"
                        data={props.data.vorname}
                        updaterValue={props.updaterValue('vorname')}
                        updaterTouch={props.updaterTouch('vorname')}
                        required={props.konfiguration.pflichtfelder.vorname}
                        validator={
                            props.konfiguration.pflichtfelder.vorname
                            ?() => validatorText(props,
                                "vorname",
                                rulesText(true,2)
                            )
                            :() => validatorResult(true)
                        }
                        inputProps={{ 'aria-label': 'Vorname' }}
                    />
                </Grid>
                }

                {props.data['personTyp'].value == "istInstitution" &&
                <Grid item lg={6} md={4} sm={6} xs={12}>
                    <CustomTextFieldNGX
                        label="Nachname Ansprechpartner"
                        data={props.data.nachname}
                        updaterValue={props.updaterValue('nachname')}
                        updaterTouch={props.updaterTouch('nachname')}
                        required={props.konfiguration.pflichtfelder.nachnameJuristischePerson}
                        validator={
                            props.konfiguration.pflichtfelder.nachnameJuristischePerson
                            ?() => validatorText(props,
                                "nachname",
                                rulesText(true,2)
                            )
                            :() => validatorResult(true)
                        }
                        inputProps={{ 'aria-label': 'Nachname' }}
                    />
                </Grid>
                }

                {props.data['personTyp'].value != "istInstitution" &&
                <Grid item lg={6} md={4} sm={6} xs={12}>
                    <CustomTextFieldNGX
                        label="Nachname"
                        data={props.data.nachname}
                        updaterValue={props.updaterValue('nachname')}
                        updaterTouch={props.updaterTouch('nachname')}
                        required={props.konfiguration.pflichtfelder.nachname}
                        validator={
                            props.konfiguration.pflichtfelder.nachname
                            ?() => validatorText(props,
                                "nachname",
                                rulesText(true,2)
                            )
                            :() => validatorResult(true)
                        }
                        inputProps={{ 'aria-label': 'Nachname' }}
                    />
                </Grid>
                }

                <Grid item md={4} xs={9}>
                    <CustomTextFieldNGX
                        label="Straße"
                        data={props.data.strasse}
                        updaterValue={props.updaterValue('strasse')}
                        updaterTouch={props.updaterTouch('strasse')}
                        required={props.konfiguration.pflichtfelder.strasse}
                        validator={
                            props.konfiguration.pflichtfelder.strasse
                            ?() => validatorText(props,
                                "strasse",
                                rulesText(true,2)
                            )
                            :() => validatorResult(true)
                        }
                        inputProps={{ 'aria-label': 'Strasse' }}
                    />
                </Grid>

                <Grid item md={2} xs={3}>
                    <CustomTextFieldNGX
                        label="Hausnummer"
                        data={props.data.hausnummer}
                        updaterValue={props.updaterValue('hausnummer')}
                        updaterTouch={props.updaterTouch('hausnummer')}
                        required={props.konfiguration.pflichtfelder.hausnummer}
                        validator={
                            props.konfiguration.pflichtfelder.hausnummer
                            ?() => validatorText(props,
                                "hausnummer",
                                rulesText(true)
                            )
                            :() => validatorResult(true)
                        }
                        inputProps={{ 'aria-label': 'Hausnummer' }}
                    />
                </Grid>

                <Grid item md={2} xs={3}>
                    <AutocompletePlz
                        label="PLZ"
                        data={props.data.plz}
                        plzVorschlagsliste={props.data.plzVorschlagsliste.value}
                        updaterValueTextInput={
                            (input) => {
                                props.updaterValue('plz')(input)
                            }

                        }
                        updaterOrt={
                            (value) => {
                                props.updaterValue('ort')(value)
                            }

                        }
                        updaterPlzVorschlagsliste={
                            (input) => {
                                WebServiceGet(
                                    props.restLadePlz,
                                    input,
                                    (data) => {
                                        props.updaterValue('plzVorschlagsliste')(data)
                                    }
                                )
                            }
                        }
                        updaterTouch={props.updaterTouch('plz')}
                        required={props.konfiguration.pflichtfelder.plz}
                        validator={
                            () => {
                                useEffect(() => {
                                    if (props.data.plz.touched) {
                                        let res = ValidatorInputCustomPlz(props.data.plz.value, props.konfiguration.pflichtfelder.plz)
                                        if (res.valid) {
                                            props.updaterValid("plz")(true)
                                        } else {
                                            props.updaterValid("plz")(false)
                                        }
                                    }
                                });
                                if (props.data.plz.touched) {
                                    return ValidatorInputCustomPlz(props.data.plz.value, props.konfiguration.pflichtfelder.plz)
                                } else {
                                    return validatorResult(true);
                                }
                            }
                        }
                        inputProps={{ 'aria-label': 'Postleitzahl' }}
                    />
                </Grid>


                <Grid item md={4} xs={9}>
                    <CustomTextFieldNGX
                        label="Ort"
                        data={props.data.ort}
                        updaterValue={props.updaterValue('ort')}
                        updaterTouch={props.updaterTouch('ort')}
                        required={props.konfiguration.pflichtfelder.ort}
                        validator={
                            props.konfiguration.pflichtfelder.ort
                            ?() => validatorText(props,
                                "ort",
                                rulesText(true,2)
                            )
                            :() => validatorResult(true)
                        }
                        inputProps={{ 'aria-label': 'Ort' }}
                    />
                </Grid>

                {props.data['adresszusatz'].display &&
                <Grid item md={4} xs={12}>
                    <CustomTextFieldNGX
                        label="Adresszusatz"
                        data={props.data.adresszusatz}
                        updaterValue={props.updaterValue('adresszusatz')}
                        updaterTouch={props.updaterTouch('adresszusatz')}
                        placeholder="Optional"
                        validator={
                            () => validatorResult(true)
                        }
                        inputProps={{ 'aria-label': 'Adresszusatz' }}
                    />
                </Grid>
                }

                {props.data['email'].display &&
                <Grid item md={4} xs={12}>
                    <CustomTextFieldNGX
                        label="E-Mail"
                        data={props.data.email}
                        updaterValue={props.updaterValue('email')}
                        updaterTouch={props.updaterTouch('email')}
                        required={props.konfiguration.pflichtfelder.email}
                        type="email"
                        validator={
                            props.konfiguration.pflichtfelder.email
                            ?() => validatorText(props,
                                "email",
                                rulesText(true,5)
                            )
                            :() => validatorResult(true)
                        }
                        inputProps={{ 'aria-label': 'E-Mail' }}
                    />
                </Grid>
                }

                {props.data['telefon'].display &&
                <Grid item md={4} xs={12}>
                    <CustomTextFieldNGX
                        label="Telefon"
                        data={props.data.telefon}
                        updaterValue={props.updaterValue('telefon')}
                        updaterTouch={props.updaterTouch('telefon')}
                        type="tel"
                        required={props.konfiguration.pflichtfelder.telefon}
                        validator={
                            props.konfiguration.pflichtfelder.telefon
                            ?() => validatorText(props,
                                "telefon",
                                rulesText(true,5)
                            )
                            :() => validatorResult(true)     
                        }
                        inputProps={{ 'aria-label': 'Telefonnummer' }}
                    />
                </Grid>
                }

                {props.data.personalausweisnummer.display &&
                <Grid item md={4} xs={12}>
                    <CustomTextFieldNGX
                        label="Personalausweisnummer"
                        data={props.data.personalausweisnummer}
                        updaterValue={props.updaterValue('personalausweisnummer')}
                        updaterTouch={props.updaterTouch('personalausweisnummer')}
                        placeholder=""
                        validator={
                            () => validatorText(props,
                                "personalausweisnummer",
                                rulesText(false,8,9)
                            )    
                        }
                        inputProps={{ 'aria-label': 'Personalausweisnummer' }}
                    />
                </Grid>
                }

                {props.data.reisepassnummer.display &&
                <Grid item md={4} xs={12}>
                    <CustomTextFieldNGX
                        label="Reisepassnummer"
                        data={props.data.reisepassnummer}
                        updaterValue={props.updaterValue('reisepassnummer')}
                        updaterTouch={props.updaterTouch('reisepassnummer')}
                        placeholder=""
                        validator={
                            () => validatorText(props,
                                "reisepassnummer",
                                rulesText(false,8,9)
                            )    
                        }
                        inputProps={{ 'aria-label': 'Reisepassnummer' }}
                    />
                </Grid>
                }

                {props.fehlermeldung &&
                <Grid item xs={12}>
                    {props.fehlermeldung}
                </Grid>
                }

            </Grid>

            {props.children}

        </div>


    );
}



export default Person;
